export const formatUserFirstLast = (firstName?: string | null, lastName?: string | null) => {
  if (!firstName && !lastName) return '';
  return `${firstName ?? ''}${firstName && lastName ? ' ' : ''}${lastName ?? ''}`;
};

export const businessChallengeFullText = (challenge: string, shortened?: boolean) => {
  return challenge
    .split('-')
    .map((word) => {
      const lowered = word.toLowerCase();
      return (
        lowered === 'and' ?
          shortened ? '&'
          : lowered
        : lowered[0].toUpperCase() + lowered.slice(1)
      );
    })
    .join(' ');
};
